import { render, staticRenderFns } from "./NewReceipt.vue?vue&type=template&id=59d70034&scoped=true"
import script from "./NewReceipt.vue?vue&type=script&lang=js"
export * from "./NewReceipt.vue?vue&type=script&lang=js"
import style0 from "./NewReceipt.vue?vue&type=style&index=0&id=59d70034&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d70034",
  null
  
)

export default component.exports